module.exports = __webpack_public_path__ + "static/media/Medical Air-01.8105d07c.png";